// Las secciones de PROPIETARIO (empresas, planes, agente IA, tickets de soporte,
// selector de empresa, "ver como") solo existen en una instalación Multi Company
// (voxcentral). En 1223/1761 y en instalaciones nuevas el panel es el del cliente y
// no debe mostrarlas. La bandera es de la INSTANCIA (config.js), no del rol: un
// superadmin de 1223 sigue siendo superadmin pero no es "propietario del sistema".
export const isMultiCompany = () => !!window.__PBX_CONFIG__?.multiCompany;
